export const ENUM_PLAYLIST = 'PLAYLIST';
export const ENUM_DEEP_SEARCH = 'DEEP_SEARCH';

export const DEEP_SEARCH_REDIRECT_ENUMS = [ENUM_PLAYLIST, ENUM_DEEP_SEARCH] as const;
